module.exports = __webpack_public_path__ + "img/RU.58bdba27.svg";